
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        centerAlign: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& img": {
                height: theme.spacing(4),
                width: theme.spacing(4),
                borderRadius: theme.spacing(0.5),
                margin: theme.spacing(1)
            }
        },
    };
});
